var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoTransactions = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ico_transactions",
    d: "M166.76,88.14a9,9,0,1,0,9,9A9,9,0,0,0,166.76,88.14Zm6.038,12.149h0l-2.451,2.439a.719.719,0,0,1-1.226-.511.709.709,0,0,1,.212-.509l1.216-1.209h-9.324a.719.719,0,0,1,0-1.438h11.154a.714.714,0,0,1,.5.279A.743.743,0,0,1,172.8,100.289Zm-.5-4.329H161.141a.706.706,0,0,1-.5-.278.742.742,0,0,1,.081-.95h0l2.45-2.438a.719.719,0,1,1,1.014,1.019l-1.215,1.209h9.324a.719.719,0,1,1,0,1.438Z",
    transform: "translate(-157.76 -88.14)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoTransactions);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_transactions.7ad5cb45eb596188ec7cc441670d78a9.svg";